import Ajax from '../common/ajax'
import OSS from 'ali-oss'
import ElementUI from 'element-ui'
import store from '../store/index'

export default {
  fileType: {
    'application/pdf': '.pdf',
    'image/jpeg': '.jpg',
    'image/png': '.png',
    'image/gif': '.gif',
    'audio/mp3': '.mp3',
    'video/mpeg4': '.mp4',
    'application/vnd.ms-powerpoint': '.ppt',
    'application/x-ppt': '.ppt',
    'text/plain': '.txt',
    'application/vnd.ms-excel': '.xls',
    'application/x-xls': '.xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xls',
    'text/xml': '.xml',
    'application/msword': '.doc',
    'video/avi': '.avi',
    'application/x-msdownload': '.exe',
    'text/html': '.html',
    'application/x-jpg': '.jpg',
    'application/x-javascript': '.js',
    'application/x-png': '.png',
    'application/json': 'json',
    'application/vnd.adobe.workflow': '.awf'
  },
  getOssSts (roleName) {
    return Ajax.get(`/api/gradeExaminee/v1/vip/ossSts/${roleName}`, {}, { showLoading: false })
  },
  base64ToFile (base64, name) {
    let arr = base64.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let fix = this.fileType[mime]
    let bstr = window.atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new window.File([u8arr], name + '-' + Date.now() + fix, { type: mime })
  },
  uploadOSS (file, dir = 'misc', type = '.png,.jpg,.gif', roleName = 'public-read', callback) {
    return new Promise(async (resolve, reject) => {
      try {
        let typeArr = type.split(',')
        let some = typeArr.some((t) => {
          return file.name.endsWith(t)
        })
        let ftype = this.fileType[file.type]
        if (type === '*') {
        } else if (ftype && type.split(',').indexOf(ftype) > -1) {
        } else if (some) {
        } else {
          ElementUI.Message.error('不支持该文件类型')
          reject(ftype)
          return false
        }
        let ossSts = await this.getOssSts(roleName)
        let param = {
          accessKeyId: ossSts['assumeRoleResponse']['credentials']['accessKeyId'],
          accessKeySecret: ossSts['assumeRoleResponse']['credentials']['accessKeySecret'],
          stsToken: ossSts['assumeRoleResponse']['credentials']['securityToken'],
          bucket: ossSts['bucket'],
          endpoint: ossSts['endpoint'],
          resource: ossSts['resource']
        }
        let fixStr = file.name.substring(file.name.lastIndexOf('.'))
        let client = new OSS(param)
        let organizationId = store.state.currentUserInfo.organizationId
        let filePath = `${param.resource}/${organizationId}/${dir}/${Date.now()}${fixStr}`
        let method = 'put'
        if (callback) {
          method = 'multipartUpload'
        }
        client[method](filePath, file, {
          progress: async function (p) { // 获取进度条的值
            if (callback) {
              await callback(p)
            }
          }
        }).then((res) => {
          if (res && res.res && res.res.requestUrls && res.res.requestUrls.length > 0 && res.res.requestUrls[0]) {
            let fileUrl = ''
            if (roleName === 'public-read') {
              fileUrl = res.res.requestUrls[0].split('?')[0]
            } else {
              fileUrl = filePath
            }
            resolve(fileUrl)
            return false
          } else {
            reject(res)
          }
        }).catch((e) => {
          reject(e)
        })
      } catch (e) {
        reject(e)
      }
    })
  },
  signatureUrl (fullUrl, roleName = 'public-read') {
    return new Promise(async (resolve, reject) => {
      try {
        let filePath = fullUrl
        if (!filePath) {
          resolve('')
          return false
        }
        if (fullUrl.indexOf('://') > -1) {
          filePath = fullUrl.substring(fullUrl.indexOf('.com/') + 5, fullUrl.indexOf('?') > -1 ? fullUrl.indexOf('?') : fullUrl.length)
        }
        let dir = filePath.split('/')[0]
        if (['dev', 'prod', 'test'].indexOf(dir) > -1 || roleName === 'public-read') {
          let url = '//zego-davinci-public.oss-cn-shanghai.aliyuncs.com/' + filePath
          resolve(url)
          return false
        }
        let ossSts = await this.getOssSts(roleName)
        let param = {
          accessKeyId: ossSts['assumeRoleResponse']['credentials']['accessKeyId'],
          accessKeySecret: ossSts['assumeRoleResponse']['credentials']['accessKeySecret'],
          stsToken: ossSts['assumeRoleResponse']['credentials']['securityToken'],
          bucket: ossSts['bucket'],
          endpoint: ossSts['endpoint']
        }
        let client = new OSS(param)
        let result = client.signatureUrl(decodeURIComponent(filePath), {
          expires: 3600,
          response: {
            'content-disposition': 'attachment; filename="' + filePath + '"'
          }
        })
        if (result) {
          resolve(result)
        } else {
          reject(param)
        }
      } catch (e) {
        reject(e)
      }
    })
  }
}
